<template>
  <v-dialog
    v-model="open"
    max-width="1120"
    scrollable
    content-class="pricing-dialog"
  >
    <div class="pricing-dialog-card">
      <button class="pricing-dialog-close" :aria-label="$t('nav.pricing')" @click="open = false">
        <l-icon size="20">mdi-close</l-icon>
      </button>
      <pricing-section embedded @navigate="open = false"></pricing-section>
    </div>
  </v-dialog>
</template>

<script>
import PricingSection from './PricingSection.vue';

/**
 * Diálogo global con la tabla de precios. Cualquier componente lo abre con
 *   this.$root.$emit('open-pricing')
 * Se monta una sola vez (en App.vue) y escucha ese evento.
 */
export default {
  name: 'PricingDialog',
  components: { PricingSection },
  data: () => ({ open: false }),
  methods: {
    show() {
      this.open = true;
    },
  },
  watch: {
    // Cierra al navegar (p. ej. tras ir a /login o /download desde la tabla).
    $route() {
      this.open = false;
    },
  },
  mounted() {
    this.$root.$on('open-pricing', this.show);
  },
  beforeDestroy() {
    this.$root.$off('open-pricing', this.show);
  },
};
</script>

<style scoped>
.pricing-dialog-card {
  position: relative;
  background: var(--lp-bg);
  border-radius: var(--lp-radius-lg);
  overflow: hidden;
}
.pricing-dialog-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 3;
  width: 40px;
  height: 40px;
  border-radius: 11px;
  border: 1px solid var(--lp-line);
  background: var(--lp-surface);
  color: var(--lp-ink-2);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, color 0.15s ease;
}
.pricing-dialog-close:hover {
  background: var(--lp-bg-subtle);
  color: var(--lp-ink);
}
</style>

<style>
.pricing-dialog {
  border-radius: var(--lp-radius-lg);
  box-shadow: var(--lp-shadow-lg);
}
</style>
